/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Colordefinitions1Inputs */

const en__field_colordefinitions1 = /** @type {(inputs: _Field_Colordefinitions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farben`)
};

const de__field_colordefinitions1 = /** @type {(inputs: _Field_Colordefinitions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farben`)
};

/**
* | output |
* | --- |
* | "Farben" |
*
* @param {_Field_Colordefinitions1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_colordefinitions1 = /** @type {((inputs?: _Field_Colordefinitions1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Colordefinitions1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_colordefinitions1(inputs)
	return de__field_colordefinitions1(inputs)
});
export { _field_colordefinitions1 as "_field_colorDefinitions" }